export class AppError extends Error {
  constructor(
    public readonly message: string,
    public readonly payload?: Record<string, unknown>
  ) {
    super(message)
  }
}
